<template>
  <Navbar />
  <router-view v-slot="{ Component }">
    <Transition name="fade">
      <component :is="Component" />
    </Transition>
  </router-view>
  <Footer v-if="$beet.isReady" />
  <Gdpr v-if="gtm" :options="{ backgroundColor: '#faf9f4' }" />
</template>
<script>
import Gdpr from '@/components/gdpr/Gdpr.vue'
import Navbar from '@/components/navigation/Navbar.vue'
import Footer from '@/components/sections/Footer.vue'
import { useLangRouter } from '@/extentions/langRouter'

export default {
  name: 'app',
  components: {
    Gdpr,
    Navbar,
    Footer,
  },
  setup() {
    useLangRouter()

    return { gtm: import.meta.env.VITE_APP_GTM }
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
  mounted() {
    window.setTimeout(() => {
      if (this.$route.hash)
        document
          .getElementById(this.$route.hash.replace('#', ''))
          .scrollIntoView({ behavior: 'smooth' })
    }, 1000)
  },
}
</script>
